import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import style from './ResultsVisualization.scss';
import { ChoiceAndResult, ChoiceLabel } from './childcomponents';
import BackgroundPlayer from './childcomponents/BackgroundPlayer.component';

class ResultsVisualization extends Component {
	constructor(props) {
		super(props);
		this.minPercentage = 8;
	}


	calcPercentage(numVotes = 0, totalVotes) {
		if (this.props.showResults) {
			if (totalVotes) {
				return Math.max(this.minPercentage, (numVotes / totalVotes) * 90).toFixed(2);
			}
			return parseInt(this.minPercentage.toFixed(2), 10);
		}
		return this.minPercentage;
	}


	render() {
		const {
			theming,
			backgroundUrl,
			questionText,
			locale,
			choices,
			questionIndex,
			background,
		} = this.props;

		const wrapperStyles = {};
		if (backgroundUrl) {
			wrapperStyles.background = `transparent url(${backgroundUrl}) no-repeat 50% 50% / cover`;
		}

		const resultsTheming = theming['styles.interactions.polls.studio.results'] || {};
		const gridTheming = theming['styles.interactions.polls.studio.results.grid'] || {};
		const questionTheming = theming['styles.interactions.polls.studio.results.question'] || {};
		const questionIndexTheming = theming['styles.interactions.polls.studio.results.question_index'] || {};
		const questionTitleTheming = theming['styles.interactions.polls.studio.results.question_title'] || {};


		const total = choices.reduce((currentTotal, choice) => currentTotal + choice.numVotes, 0);
		const choicesLimited = choices
			.sort((prev, curr) => prev.numVotes - curr.numVotes)
			.reverse()
			.slice(0, 10)
			// Sort again by idx to preserve initial order
			.sort((prev, curr) => prev.idx - curr.idx);
		const maxResult = choicesLimited.reduce((carry, current) => Math.max(carry, current.numVotes), 0);

		const classes = classnames({
			[style.results__wrapper]: true,
			[style.results__wrapperStudio]: true,
			[style.visible]: true,
		});

		return (
			<div className={classes} style={{ ...wrapperStyles, ...resultsTheming }}>
				<div className={classnames({ [style.results]: true, [style.results__many]: (choicesLimited.length > 4) })}>
					<div className={classnames(style.hasColumns, style.fullheight)}>
						<div className={classnames(style.column, style.columnPollQuestion, style.flexDirectionColumn, style.justifyCenter)}>
							<div>
								<span className={classnames(style.results__question__title)} style={questionTitleTheming}>{locale['polls.question.message'] || ''}</span>
							</div>
							<div>
								<div className={style.results__question} style={questionTheming}>
									<span style={questionIndexTheming} className={style.results__question__index}>{questionIndex ? `Q${questionIndex}. ` : ''}</span>
									{questionText}
								</div>
							</div>
						</div>
						<div className={classnames(style.column, style.columnPollResults, style.justifyCenter)}>
							<div className={classnames(style.results__choices_and_labels)}>
								<div style={gridTheming} className={classnames(style.results__choices, style.results__choicesBars)} data-count={this.props.choices.length}>
									{
										choicesLimited.map(choice => (
											<ChoiceAndResult
												theming={theming}
												key={`resultschoice_${choice.idx}`}
												numVotes={choice.numVotes}
												totalVotes={total}
												showLabel={this.props.showResults}
												percentage={this.calcPercentage(choice.numVotes, maxResult)}
												{...choice}
											/>
										))
									}
								</div>
								<div className={classnames(style.results__choices, style.results__choicesLabels)} data-count={this.props.choices.length}>
									{
										choicesLimited.map(choice => (
											<ChoiceLabel
												key={`resultschoice_label_${choice.idx}`}
												theming={theming}
												{...choice}
											/>
										))
									}
								</div>
							</div>
						</div>
					</div>
				</div>
				{
					background && (
						<BackgroundPlayer {...background} />
					)
				}
			</div>
		);
	}
}
ResultsVisualization.propTypes = {
	choices: PropTypes.arrayOf(
		PropTypes.shape({
			numVotes: PropTypes.number.isRequired,
			idx: PropTypes.number.isRequired,
			title: PropTypes.string.isRequired,
			image: PropTypes.object, // eslint-disable-line react/forbid-prop-types
			correct: PropTypes.bool,
		})
	).isRequired,
	backgroundUrl: PropTypes.string,
	questionText: PropTypes.string.isRequired,
	questionIndex: PropTypes.number.isRequired,
	showResults: PropTypes.bool,
	locale: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	theming: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	background: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

ResultsVisualization.defaultProps = {
	showResults: false,
};

export default ResultsVisualization;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/resultsvisualization/ResultsVisualization.component.js